import axios, { AxiosInstance } from 'axios'
import { inject, InjectionKey } from 'vue'

export const apiKey: InjectionKey<AxiosInstance> = Symbol()
export const generateApi = (fingerprint: string) => {
  return axios.create({
    baseURL: '/api/', 
    headers: { 'X-Fingerprint': fingerprint }
  })
}
export const useApi = (): AxiosInstance => {
  const axios = inject(apiKey)
  if (!axios) throw Error('Could not inject axios')
  return axios
}
